import { Point, UTM, colorize } from 'uweb/utils'
import { THREE, ThreeView } from 'uweb/three'
import { MapView } from 'uweb/maptalks'
import { Delay, log, KeyValue } from 'utils/web'

const stringToColour = (str: string) => {
    let hash = 0;
    str.split('').forEach(char => { hash = char.charCodeAt(0) + ((hash << 5) - hash) })
    let colour = '#'
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff
        colour += value.toString(16).padStart(2, '0')
    }
    return colour
}

export class LineString {

    Three
    Maptalks
    obj: any = {}

    constructor({ Maptalks, Three }: { Maptalks?: MapView, Three?: ThreeView }) {
        this.Three = Three
        this.Maptalks = Maptalks
    }

    altitude = (el: number) => {
        const elevation = el || 1500
        const vector3 = this.Maptalks?.threeLayer.distanceToVector3(elevation, elevation)
        const zPos = vector3.x
        return zPos
    }

    add = (group: any, rows: tItem[]) => {
        const is = (m: any[]) => isNaN(m[0]) || isNaN(m[1]) || isNaN(m[2]) ? false : true
        try {

            let is_3D_enabled = KeyValue('3D') === 'yes'
            let is_3D_diff = Number(KeyValue('Elevation'))
            const [nm, lt] = KeyValue('Zone').split(',')

            for (const n of rows) {

                const { Coords, EntityHandle } = n
                const color = stringToColour(EntityHandle)

                const material = new THREE.LineBasicMaterial({ color: color, linewidth: 2, linecap: 'round', linejoin: 'round' })

                if (this.Maptalks) {

                    const llPoints: { lng: number, lat: number, alt: number }[] = []
                    for (const x of Coords) if (is(x)) {
                        const ll = UTM.convertUtmToLatLng(x[0], x[1], nm, lt)
                        const alt = is_3D_enabled ? this.altitude(x[2] - is_3D_diff) : 0
                        llPoints.push({ lng: Number(ll.lng), lat: Number(ll.lat), alt })
                    }

                    if (llPoints.length < 2) return

                    // anchor at the first point — geometry will be relative to this
                    const args: any = { x: llPoints[0].lng, y: llPoints[0].lat, z: 0 }
                    const anchor = this.Maptalks?.threeLayer.coordinateToVector3(args, 0)

                    const fpoints = llPoints.map(p => {
                        const args: any = { x: p.lng, y: p.lat, z: 0 }
                        const w: any = this.Maptalks?.threeLayer.coordinateToVector3(args, 0)
                        return new THREE.Vector3(w.x - anchor.x, w.y - anchor.y, p.alt)
                    })

                    const fgeometry = new THREE.BufferGeometry().setFromPoints(fpoints)
                    const fline = new THREE.Line(fgeometry, material)
                    fline.position.copy(anchor)   // world offset lives on the transform, not the vertices
                    fline.computeLineDistances()
                    group.add(fline)

                }

            }

        } catch (err: any) { log.error(`[LineString.add()]: ${err.message}`) }
    }

    remove = (key: string) => {

        if (this.obj.hasOwnProperty(key)) {

            const group = this.obj[key]
            this.Maptalks?.threeLayer.removeMesh(group)
            const nodes: any = []
            group.traverse((child: any) => { nodes.push(child) })
            nodes.forEach((node: any) => { node.removeFromParent() })
            group.clear()
            delete this.obj[key]

        }

    }

    remove_all = () => {
        for (const x in this.obj) this.remove(x)
    }

    insert = (key: string, rows: tItem[]) => {

        if (this.obj.hasOwnProperty(key)) this.remove(key)
        else {

            const group = new THREE.Group()
            this.obj[key] = group
            this.add(group, rows)
            this.Maptalks?.threeLayer.addMesh(group)

        }

    }

}